class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    // Get the announcement items container and the announcement items
    this.announcementItemsContainer = this.querySelector('.announcement-items__container');
    this.announcementItems = this.querySelectorAll('.announcement-item');

    // Get the close button
    this.close = this.querySelector('.announcement-bar__close');

    // Get the display status
    this.displayStatus = localStorage.getItem('announcement-bar:is-closed');

    // Disable the bar if the display status is set
    if (this.displayStatus) this.disableBar()

    // Clone the first slide and append it to the container
    this.cloneSlide();

    // Update the announcement items to include the cloned slide
    this.announcementItems = this.querySelectorAll('.announcement-item');

    // Set the animation duration (in seconds)
    this.animationDuration = Number(this.dataset.duration || 2);

    // Set the delay between each slide's animation (in seconds)
    this.delay = Number(this.dataset.delay || 1);

    // Set the initial slide index
    this.slideIndex = 0;

    // Run the updateSlide function immediately
    this.updateSlide();

    // Start the animation
    this.startAnimation();

    // Add event listeners
    this.addEventListeners();
  }

  addEventListeners() {
    // Add an event listener for the close button
    this.close?.addEventListener('click', () => {
      this.disableBar();
      this.setDisplayStatus();
    });

    // Add an event listener for the transitionend event
    this.announcementItemsContainer.addEventListener('transitionend', () => this.resetSlide());

    // Add event listeners for the visibilitychange event
    document.addEventListener('visibilitychange', () => {
      document.hidden ? this.stopAnimation() : this.startAnimation();
    });
  }

  cloneSlide() {
    // Clone the first slide and append it to the container
    const firstSlideClone = this.announcementItems[0].cloneNode(true);

    // Append the cloned slide to the container
    this.announcementItemsContainer.appendChild(firstSlideClone);

    // Update the announcement items to include the cloned slide
    this.announcementItems = this.querySelectorAll('.announcement-item');
  }

  startAnimation() {
    // Run the updateSlide function every few seconds
    this.intervalId = setInterval(() => this.updateSlide(), (this.animationDuration + this.delay) * 1000);
  }

  stopAnimation() {
    // Clear the interval
    clearInterval(this.intervalId);
  }

  updateSlide() {
    // Calculate the transform value and ensure it doesn't exceed the maximum value
    const transformValue = this.slideIndex * -100 >= this.announcementItems.length * -100 ? this.slideIndex * -100 : 0;

    // Apply the transform value to the announcement items container
    this.announcementItemsContainer.classList.add('js-transitioning');
    this.announcementItemsContainer.style.transform = `translateX(${transformValue}%)`;

    // Increment the slide index
    this.slideIndex++;
  }

  resetSlide() {
    // If the slide index is equal to the number of slides, reset it
    if (this.slideIndex === this.announcementItems.length) {
      // Reset the slide index
      this.slideIndex = 1;

      // Remove the transition temporarily
      this.announcementItemsContainer.classList.remove('js-transitioning');

      // Reset the transform property
      this.announcementItemsContainer.style.transform = `translateX(0%)`;
    }
  }

  setDisplayStatus() {
    localStorage.setItem('announcement-bar:is-closed', "true");
  }

  disableBar() {
    this.classList.add('announcement-bar--is-closed');
    this.stopAnimation();
  }
}

customElements.define('announcement-bar', AnnouncementBar);